import { updateItemInCollection } from "directus/src/operations";

export async function updateTechStack({ item, techStackId }) {
  try {
    const data = await updateItemInCollection("tech_stack", techStackId, item);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}
